import {
    Pipe, PipeTransform
} from "@angular/core";

import {
    Enum, EnumUtil, EnumValue
} from "@shopliftr/common-js/data";

/**
 * Angular pipe that transforms enum values into human-readable display strings
 *
 * This pipe uses EnumUtil.getDisplayValue to render enum values, which:
 * - Returns registered display values for enums with EnumUtil.registerDisplayValues
 * - Automatically formats string enum values (e.g., "SIMPLE_VALUE" → "Simple Value")
 * - Returns string representation for numeric enum values
 * - Returns "Unknown" for invalid values when targetEnum is provided
 * - Returns undefined for null/undefined values
 *
 * @example
 * // With registered display values
 * {{ CampaignType.Display | mgdEnumDisplay:CampaignType }}
 * // Output: "Display"
 *
 * @example
 * // Without registered display values (automatic formatting)
 * {{ "SIMPLE_VALUE" | mgdEnumDisplay }}
 * // Output: "Simple Value"
 *
 * @example
 * // Array of enum values
 * {{ [CampaignType.Display, CampaignType.Video] | mgdEnumDisplay:CampaignType }}
 * // Output: "Display ,Video"
 */
@Pipe({ name: "mgdEnumDisplay" })
export class EnumDisplayPipe implements PipeTransform {

    /**
     * Transforms an enum value or array of enum values into display strings
     *
     * @param value The enum value or array of enum values to transform
     * @param targetEnum Optional enum reference for registered display values and validation
     * @returns Human-readable display string, or undefined for null/undefined values
     */
    transform(value: EnumValue | Array<EnumValue>, targetEnum?: Enum): string {

        if (Array.isArray(value)) {

            return value.map((enumValue) => this.transform(enumValue, targetEnum)).join(", ");
        }
        else {
            return EnumUtil.getDisplayValue(value, targetEnum);
        }
    }
}
